class SubscriptionModal extends HTMLElement {
  constructor() {
    super();

    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieKey = 'subscription-modal';

    this.states = {
      bodyActive: 'modal-open',
      visible: 'is-visible',
      hiding: 'is-hiding',
      imageVisible: 'has-image'
    };

    this.modal = this.querySelector('.modal-wrapper');

    if (this.querySelector('.form__note')) {
      this.show();
    }

    // Subscribed: don't ask again for a year
    this.subscribed = Boolean(this.querySelector('.subscription-form__note--success'));
    if (this.subscribed) {
      this.storeCookie(this.cookieKey, 365);
    }

    this.querySelectorAll('[data-modal-toggle]').forEach((btn) =>
      btn.addEventListener('click', this.handleToggle.bind(this))
    );

    if (!this.getCookie(this.cookieKey) || this.dataset.testMode === 'true') {
      this.start();
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onLoadHandler = this.handleLoad.bind(this);
      this.onSelectHandler = this.handleSelect.bind(this);
      this.onDeselectHandler = this.handleDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onLoadHandler);
      document.addEventListener('shopify:section:select', this.onSelectHandler);
      document.addEventListener('shopify:section:deselect', this.onDeselectHandler);
    }
  }

  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onLoadHandler);
      document.removeEventListener('shopify:section:select', this.onSelectHandler);
      document.removeEventListener('shopify:section:deselect', this.onDeselectHandler);
      document.body.classList.remove(this.states.bodyActive);
    }
  }

  handleLoad(event) {
    this.filterEvent(event, this.show.bind(this));
  }

  handleSelect(event) {
    this.filterEvent(event, this.show.bind(this));
  }

  handleDeselect(event) {
    this.filterEvent(event, this.hide.bind(this));
  }

  start() {
    if (Shopify && Shopify.designMode) return;
    setTimeout(() => {
      if (this.dataset.disabled !== 'true') this.show();
    }, parseInt(this.dataset.delay) * 1000);
  }

  handleToggle(event) {
    event.preventDefault();
    this.modal.classList.contains(this.states.visible) ? this.hide() : this.show();
  }

  show() {
    document.body.classList.remove(this.states.bodyActive);
    this.modal.classList.add(this.states.visible);
    // has-image reserves 34rem for the photo; without one it shoves the panel off-center
    if (this.querySelector('.modal-subscription__media')) {
      setTimeout(() => this.modal.classList.add(this.states.imageVisible), 500);
    }

    if (this.modal.dataset.placement === 'center') {
      document.body.classList.add(this.states.bodyActive);
    }
  }

  hide() {
    this.modal.classList.add(this.states.hiding);
    setTimeout(() => {
      this.modal.classList.remove(this.states.visible);
      this.modal.classList.remove(this.states.hiding);
      this.modal.classList.remove(this.states.imageVisible);

      if (this.modal.dataset.placement === 'center') {
        document.body.classList.remove(this.states.bodyActive);
      }
    }, 400);

    if (this.dataset.testMode === 'true') {
      this.clearCookie(this.cookieKey);
      return;
    }

    this.storeCookie(this.cookieKey, this.subscribed ? 365 : this.dataset.expiry);
  }

  getCookie(key) {
    const cookie = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
    return cookie ? cookie[2] : null;
  }

  storeCookie(key, days) {
    document.cookie = `${key}=true; max-age=${days * 24 * 60 * 60}; path=/`;
  }

  clearCookie(key) {
    document.cookie = `${key}=; max-age=0; path=/`;
  }

  filterEvent(event, callback) {
    let shouldRun = false;
    if (event.type.includes('shopify:section')) {
      if (
        this.hasAttribute('data-section-id') &&
        this.getAttribute('data-section-id') === event.detail.sectionId
      ) {
        shouldRun = true;
      }
    }
    if (shouldRun) callback(event);
  }
}

customElements.define('subscription-modal', SubscriptionModal);